export default {
  'failure_flags.page_name': 'Failure Flags',
  'failure_flags.label.plural': 'Failure Flags',
  'failure_flags.label.singular': 'Failure Flag',
  'failure_flags.create_experiment_button': 'Experiment',

  // modals
  'failure_flags.modal.remove_protection.title':
    'Remove Protection for {{name}}?',
  'failure_flags.modal.protect.content_text.application':
    'This application will be excluded from future experiments.',

  // Getting Started
  'failure_flags.getting_started.title': 'Getting Started',
  'failure_flags.incomplete_guide.applications_connected.title':
    'Connect your application',
  'failure_flags.incomplete_guide.applications_connected.description1': 'Our ',
  'failure_flags.incomplete_guide.applications_connected.description2':
    'documentation',
  'failure_flags.incomplete_guide.applications_connected.description3':
    ' will guide you based on your technology stack.',
  'failure_flags.incomplete_guide.applications_detected.title':
    'Annotate your code',
  'failure_flags.incomplete_guide.applications_detected.description':
    'Use one of the SDKs linked above to add Failure Flags to your code. Any Failure Flags you add to your connected applications will appear in the list below.',
  'failure_flags.incomplete_guide.experiments_created.title':
    'Create your first experiment',
  'failure_flags.incomplete_guide.experiments_created.description':
    'Experiments are composed of a failure flag and at least one application. Once we detect at least one of each, you will be able to create and run your first experiment.',

  // failure flags list
  'failure_flags.flags_list.empty_text': 'No Failure Flags detected',
  'failure_flags.flags_list.empty_text2': 'Learn how to annotate your code',
  'failure_flags.flags_list.headers.name': 'Name',
  'failure_flags.flags_list.headers.protected': 'Protected',
  'failure_flags.flags_list.protected.yes': 'Yes',
  'failure_flags.flags_list.protected.no': 'No',
  'failure_flags.flags_list.status.unknown': 'Idle', // TODO not sure yet
  'failure_flags.experiments_list.view_progress': 'View Progress',
  'failure_flags.experiments_list.search': 'Search',

  // flag page
  'failure_flags.flag_page.title': 'Flag',
  'failure_flags.flag_page.header': 'Flag: {{flagName}}',
  'failure_flags.flag_page.retrieve.error':
    'There was an issue while retrieving this Flag',
  'failure_flags.flag_page.variants.empty': 'No Applications',
  'failure_flags.flag_page.variants.label': 'Applications Using this Flag',
  'failure_flags.flag_page.variants.heading.name': 'Application',
  'failure_flags.flag_page.experiments.empty': 'No experiments',
  'failure_flags.flag_page.experiments.label':
    'Experiments Targeting this Flag',
  'failure_flags.flag_page.experiments.heading.name': 'Experiment',
  'failure_flags.flag_page.protect.success': 'Flag updated successfully',

  // experiments list
  'failure_flags.experiments_list.headers.name': 'Name',
  'failure_flags.experiments_list.headers.flag': 'Failure Flag',
  'failure_flags.experiments_list.headers.application': 'Application',
  'failure_flags.experiments_list.headers.last_run': 'Last Run',
  'failure_flags.experiments_list.empty_text': 'No experiments created',
  'failure_flags.experiments_list.status.in_use': 'In Use',
  'failure_flags.experiments_list.status.unknown': 'Unknown',
  'failure_flags.experiments_list.run_experiment.error_message':
    'There was an issue running the experiment {{name}}. Please try again later.',
  'failure_flags.experiments_list.run_experiment.running':
    'Running Experiment {{name}}',

  // create experiment
  'failure_flags.create.create_experiment': 'Create an Experiment',

  // run button
  'failure_flags.experiment_page.run_experiment.error':
    'There was an issue running the experiment {{name}}. Please try again later.',
  'failure_flags.experiment_page.run_experiment.success':
    'Running Experiment {{name}}',
  // delete button
  'failure_flags.experiment_page.delete_experiment.error':
    'There was an issue deleting the experiment {{name}}. Please try again later.',
  'failure_flags.experiment_page.delete_experiment.error_running':
    'Cannot delete experiment {{name}} while it is running. Please try again later.',
  'failure_flags.experiment_page.delete_experiment.success':
    'Deleted Experiment {{name}}',
  'failure_flags.experiment_page.delete_experiment.modal_title':
    'Delete Experiment {{name}}?',
  // halt button
  'failure_flags.experiment_page.halt_experiment.error':
    'There was an issue halting the experiment {{name}}. Please try again later.',
  'failure_flags.experiment_page.halt_experiment.success':
    'Halted Experiment {{name}}'
}
